import { useMutation } from "@tanstack/react-query";
import api from "@/lib/axios";
import { toast } from "react-toastify";
import { endpoints } from "@/lib/utils/copyAndNaming/endpoints";
import { toastOptions } from "@/lib/utils/constantValues";
import { WriteLog } from "@/features/logs/types/log.types";

export const createLog = async (log: WriteLog): Promise<WriteLog | null> => {
  const { data: response } = await api
    .post(`/api/${endpoints.logs}/`, log)
    .catch((error) => {
      // If the user is not found, return null
      if (error.response.status === 404) {
        return { data: null };
      }
      throw error;
    });
  return {
    ...log,
    id: response.id,
  };
};

export const useCreateLog = () => {
  return useMutation({
    mutationFn: createLog,
    onSuccess: () => {},
    onError: () => {
      toast.error(
        "Si è verificato un errore durante la creazione del log.",
        toastOptions
      );
    },
  });
};
